const sessionStorageVars = {
  INACTIVITY_LOGOUT: 'showInactivityLogoutNotification',
}

export {sessionStorageVars}
